"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gallery = void 0;
exports.RenderGallery = RenderGallery;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = require("react");
const app_1 = require("app");
const webexUI_1 = require("webexUI");
const containers_1 = require("./containers");
const screenBreakpoints = [webexUI_1.Breakpoint.SMScreen, webexUI_1.Breakpoint.UpToTablet];
const Gallery = ({ uniqueClassName, playButtonAriaLabel, popupAriaLabel, closeButtonAriaLabel, galleryProperties, hideThumbnails, isMediaGallery, }) => {
    const galleryItems = React.useMemo(() => JSON.parse(galleryProperties), [galleryProperties]);
    const [isTablet] = (0, webexUI_1.useScreenCheck)({ screenBreakpoints });
    return ((0, jsx_runtime_1.jsx)(containers_1.DesktopGallery, { galleryItems: galleryItems, isTablet: isTablet, uniqueClassName: uniqueClassName, playButtonAriaLabel: playButtonAriaLabel, popupAriaLabel: popupAriaLabel, closeButtonAriaLabel: closeButtonAriaLabel, hideThumbnails: hideThumbnails, isMediaGallery: isMediaGallery }));
};
exports.Gallery = Gallery;
function RenderGallery(data, element) {
    (0, app_1.reactDOMRender)((0, jsx_runtime_1.jsx)(exports.Gallery, Object.assign({}, data)), element);
}
